import { PublicKey } from "@solana/web3.js";

export function isValidPublicKey(address: string) {
    try {
        if (!address) return false;
        new PublicKey(address);
        return true;
    } catch {
        return false;
    }
}
